<template>
  <div>
    <cadastro-base :salvar="salvarGrupoEmpresarial">
      <template slot="conteudo">
        <b-row>
          <b-form-group
            class="col-12 my-0 pb-0"
          >
            <b-form-checkbox
              v-model="form.ativo"
              checked="true"
              class="custom-control-primary"
              style="float:right"
              name="check-button"
              switch
            >
              <label style="font-size: 1rem">Grupo Empresarial Ativo</label>
            </b-form-checkbox>
          </b-form-group>
        </b-row>
        <b-row>
          <b-form-group
            label="Nome"
            class="col-md-12"
          >
            <validation-provider
              #default="{ errors }"
              rules="required"
              name="Nome"
            >
              <b-form-input
                v-model="form.nome"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-row>
        <b-row>
          <b-col cols="12">
            <empresa-select
              v-model="form.empresas"
              :multiple="true"
              :require="true"
            />
          </b-col>
        </b-row>
      </template>
    </cadastro-base>
  </div>
</template>

<style lang="scss">
.company-identification {
  & span {
    font-size: 0.65rem;
  }
}
</style>

<script>
import { ValidationProvider } from 'vee-validate'
import {
  required,
} from '@validations'
import CadastroBase from '@/shared/components/cadastro-base/CadastroBase.vue'
import api from '@/app-modulo/comuns/grupo-empresarial/shared/services/api'

export default {
  name: 'GrupoEmpresarial',
  components: {
    CadastroBase,
    ValidationProvider,
    EmpresaSelect: () => import('@/shared/components/empresa-select/EmpresaSelect.vue'),
  },
  data() {
    return {
      required,
      form: {
        nome: '',
        empresas: null,
        ativo: true,
        cor: 'none',
        processosSocietario: 0,
      },
      immutableForm: {},
    }
  },
  created() {
    this.state = this.$route.path.indexOf('editar') > 0 ? 'editar' : 'novo'
    if (this.state === 'editar') {
      this.carregar(this.$route.params.id)
    }
  },
  methods: {
    carregar(id) {
      api.getGrupoEmpresarial(id)
        .then(payload => {
          this.form = payload.data
        })
    },
    salvarGrupoEmpresarial() {
      return new Promise((resolve, reject) => {
        if (this.state === 'novo') {
          api.createGrupoEmpresarial(this.form)
            .then(() => {
              this.$router.go(-1)
              resolve('Grupo Empresarial cadastrado com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        } else {
          api.updateGrupoEmpresarial(this.form.id, this.form)
            .then(() => {
              this.$router.go(-1)
              resolve('Grupo Empresarial alterado com sucesso')
            })
            .catch(err => {
              reject(err)
            })
        }
      })
    },
    cancelar() {
      this.$router.go(-1)
    },
  },
}
</script>
